import React from 'react';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';

const Blogs = () => {
    return (
        <div>
            <Navbar />
            <h2 style={{ padding: '300px' }} className='blogs'>Blogs Loading...</h2>
            <Footer />
        </div>
    );
};

export default Blogs;